module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-1-73514aed93c3a2fc7613e5a5e32c2ce3.png";